jQuery(function ($) {

	$(document).on( 'submit', '#producta_search', function() {
	    var $form = $(this),
		    $input = $form.find('input[name="s"]'),
		    query = $input.val(),
		    $content = $('#producta_search_result'),
		    $loader = $form.find('.producta-loading');

		if(query){
		    $.ajax({
		        type : 'post',
		        url : myAjax.ajaxurl,
		        data : {
		            action : 'load_search_results',
		            query : query
		        },
		        beforeSend: function() {
		            $input.prop('disabled', true);
		            $loader.show();
		        },
		        success : function( response ) {
		            $input.prop('disabled', false);
		            $loader.hide();
		            $content.fadeOut('normal',function(){
		            	$(this).html( response ).fadeIn('normal',function(){
	            			$('#search_overlay').css({'height':'100%'}).animate({
	            		        scrollTop: $('#producta_search').offset().top
	            		    }, 800);
		            	});
		            });
		        }
		    });
		}

	    return false;
	});


	// Only on touch devices
	if (Modernizr.touch) {
		$('#producta_search .search-input').on("focus", function () {
		    $("body").css("position", "fixed");
		});

		$("#producta_search .search-input").on("blur", function () {
		    $("body").css("position", "static");
		});
	}
});
